<template>
  <div class="block-menu-item">

    <img :src="getImgUrl(item.pic)" />
    <router-link :to="item.url" class="block-menu-item-text">
        {{ item.label }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {item: Object},
  name: "BlockMenuItem",
  methods: {
    getImgUrl(pet) {

      return require('@/assets/images/main/' + pet + ".png")
    }
  }
}
</script>

<style scoped>

.block-menu-item {
  width: 19rem;
  height: 19rem;
  border-radius: 25px;
  vertical-align: bottom;
  padding: 1rem;
  text-align: center;
  background-color: #EBEAE7;
}

.block-menu-item-text {
  color: #2fb671;
  font-weight: 600;
  font-size: 22px;
  vertical-align: bottom;
}

</style>